/* eslint no-param-reassign: "off" */

export default {
  install(Vue, options) {
    Vue.prototype.$ym = {
      do(mode) {
        const { metrika_code } = options.store.state.data.settings;
        if (!metrika_code) return true;
        if (typeof ym !== 'function') {
          // eslint-disable-next-line no-undef
          console.log('Metrika:', metrika_code, mode);
        } else {
          // eslint-disable-next-line no-undef
          ym(metrika_code, 'reachGoal', mode);
        }
        return true;
      }
    };
  }
};
